import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import PortalLayout from "@/components/portal/PortalLayout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Borrowers from "@/pages/Borrowers";
import Loans from "@/pages/Loans";
import LoanDetail from "@/pages/LoanDetail";
import CheckingData from "@/pages/CheckingData";
import ApplicationReview from "@/pages/ApplicationReview";
import Repayments from "@/pages/Repayments";
import Calculator from "@/pages/Calculator";
import PortalHome from "@/pages/portal/PortalHome";
import PortalApply from "@/pages/portal/PortalApply";
import PortalDocuments from "@/pages/portal/PortalDocuments";
import PortalLoan from "@/pages/portal/PortalLoan";
import PortalHistory from "@/pages/portal/PortalHistory";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            element={
              <ProtectedRoute role="borrower">
                <PortalLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/portal" element={<PortalHome />} />
            <Route path="/portal/apply" element={<PortalApply />} />
            <Route path="/portal/documents" element={<PortalDocuments />} />
            <Route path="/portal/loans/:id" element={<PortalLoan />} />
            <Route path="/portal/history" element={<PortalHistory />} />
          </Route>
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/borrowers" element={<Borrowers />} />
            <Route path="/borrowers/:id" element={<CheckingData />} />
            <Route path="/loans" element={<Loans />} />
            <Route path="/loans/:id/review" element={<ApplicationReview />} />
            <Route path="/loans/:id" element={<LoanDetail />} />
            <Route path="/payments" element={<Repayments />} />
            <Route path="/calculator" element={<Calculator />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
